/** Multipart body for `POST …/attachments/bulk/` (one or more files). */
export const noteAttachmentFilesFormData = (files: Array<Blob | File>): FormData => {
  const formData = new FormData();
  for (const file of files) {
    formData.append('files', file);
  }
  return formData;
};
